import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Pagination} from 'kpc';

var _$tmp0 = {
    'flat': true,
    'total': 200,
    'size': 'large',
    'showGoto': true
};
var _$tmp1 = {
    'flat': true,
    'total': 200,
    'showGoto': true
};
var _$tmp2 = {
    'flat': true,
    'total': 200,
    'size': 'small',
    'showGoto': true
};
var _$tmp3 = {
    'flat': true,
    'total': 200,
    'size': 'mini',
    'showGoto': true
};

export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$cc(Pagination, _$tmp0),
        _$cc(Pagination, _$tmp1),
        _$cc(Pagination, _$tmp2),
        _$cc(Pagination, _$tmp3)
    ], 4);
};